webpackJsonp([9],{

/***/ 311:
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMzJweCIgaGVpZ2h0PSIzMnB4IiB2aWV3Qm94PSIwIDAgMzIgMzIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDU1LjIgKDc4MTgxKSAtIGh0dHBzOi8vc2tldGNoYXBwLmNvbSAtLT4KICAgIDx0aXRsZT5CYWNrPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGcgaWQ9IkJhY2siIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxwYXRoIGQ9Ik04LjYwOTMwNzMzLDE3LjM2MTkyNTggQzguMjYzNzQ2MDEsMTcuMjg0NDI2NiA4LDE2Ljg3MjA3MDkgOCwxNi4zNzUwMTM3IEM4LDE1Ljg3Nzk1NjUgOC4yNjM3NDYwMSwxNS40NjU2MDA4IDguNjA5MzA3MzMsMTUuMzg4MTAxNiBMMTMuMzQxNDk1NCwxMS4yNDc0MzcgQzEzLjc1NzEzMiwxMC44ODM3NTUgMTQuMzg4ODk0NiwxMC45MjU4NzI1IDE0Ljc1MjU3NjcsMTEuMzQxNTA5MSBDMTUuMTE2MjU4NywxMS43NTcxNDU3IDE1LjA3NDE0MTIsMTIuMzg4OTA4MyAxNC42NTg1MDQ2LDEyLjc1MjU5MDQgTDExLjY2MTQ0OTQsMTUuMzc1MDEzNyBMMjMuMjcyNzI3MywxNS4zNzUwMTM3IEMyMy42NzQzODg5LDE1LjM3NTAxMzcgMjQsMTUuODIyNzI5IDI0LDE2LjM3NTAxMzcgQzI0LDE2LjkyNzI5ODUgMjMuNjc0Mzg4OSwxNy4zNzUwMTM3IDIzLjI3MjcyNzMsMTcuMzc1MDEzNyBMMTEuNjYxNDQ5NCwxNy4zNzUwMTM3IEwxNC42NTg1MDQ2LDE5Ljk5NzQzNyBDMTUuMDc0MTQxMiwyMC4zNjExMTkxIDE1LjExNjI1ODcsMjAuOTkyODgxNyAxNC43NTI1NzY3LDIxLjQwODUxODMgQzE0LjM4ODg5NDYsMjEuODI0MTU0OSAxMy43NTcxMzIsMjEuODY2MjcyNCAxMy4zNDE0OTU0LDIxLjUwMjU5MDQgTDguNjA5MzA3MzMsMTcuMzYxOTI1OCBaIiBpZD0iQ29tYmluZWQtU2hhcGUiIGZpbGw9IiMwMDAwMDAiIGZpbGwtcnVsZT0ibm9uemVybyI+PC9wYXRoPgogICAgPC9nPgo8L3N2Zz4="

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__main__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_GoogleAnalytics__ = __webpack_require__(74);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "settings",
  data: function data() {
    return {
      notification: true
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(["subscriberid"])),
  watch: {
    subscriberid: function subscriberid() {
      if (this.subscriberid) {
        this.getStatus();
      }
    }
  },
  components: {},
  activated: function activated() {
    // console.log("settings-activated");
    if (!this.subscriberid) {
      // this.$router.push({ name: 'Home' });
      // return;
    } else {
      this.getStatus();
    }
  },
  beforeDestroy: function beforeDestroy() {
    // console.log("settings-beforeDestroy");
  },
  deactivated: function deactivated() {
    // console.log("settings-deactivated");
  },
  created: function created() {
    // console.log("settings");
    if (!this.subscriberid) {
      // this.$router.push({ name: 'Home' });
      // return;
    } else {
      this.getStatus();
    }
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["unsubscribeFromTopics", "subscribeVendorAndSubscriberTopics", "initFCMNotifications"]), {
    openHelpCenter: function openHelpCenter() {
      // GA
      var GA = {
        MenuItem: "Help Center"
      };
      this.menuEvent(GA);
    },
    getStatus: function getStatus() {
      var status = JSON.parse(localStorage.getItem("notificationStatus"));
      // console.log("status", status);
      if (!status) {
        this.notification = false;
      } else {
        this.subscribeVendorAndSubscriberTopics();
      }
    },
    openAboutPopup: function openAboutPopup() {
      // GA
      var GA = {
        MenuItem: "About"
      };
      this.menuEvent(GA);
      __WEBPACK_IMPORTED_MODULE_2__main__["EventBus"].$emit("AboutPopup");
    },
    notificationToggle: function notificationToggle() {
      // console.log("checked", this.notification);
      if (!this.notification) {
        this.unsubscribeFromTopics(true);
      } else {
        this.subscribeVendorAndSubscriberTopics();
        // this.initFCMNotifications();
      }
    },
    togglePurchseHistoryPopup: function togglePurchseHistoryPopup(state) {
      this.showPurchaseHistory = state;
    }
  }),
  mixins: [__WEBPACK_IMPORTED_MODULE_3__mixins_GoogleAnalytics__["a" /* default */]]
});

/***/ }),

/***/ 484:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(485);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(169)("065a4b2c", content, true, {});

/***/ }),

/***/ 485:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(168)(true);
// imports


// module
exports.push([module.i, ".page-title[data-v-df8a36e6]{color:#212121;font-family:ProximanovaBold;font-size:32px;letter-spacing:1px;line-height:49px;margin-top:2%;margin-bottom:1%}.hr-line[data-v-df8a36e6]{margin:1% 0 2%;border-bottom:1px solid hsla(0,0%,4%,.44)}.setting-list p[data-v-df8a36e6]{opacity:.9;color:#212121;font-family:ProximanovaSemibold;font-size:18px;font-style:normal;letter-spacing:.55px;line-height:27px;margin-bottom:18px;text-transform:uppercase;cursor:pointer}.marginleftright[data-v-df8a36e6]{margin-left:0;margin-right:0}.switch[data-v-df8a36e6]{position:relative;display:inline-block;width:36px;height:18px}.switch input[data-v-df8a36e6]{opacity:0;width:0;height:0}.slider[data-v-df8a36e6]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;-webkit-transition:.4s;transition:.4s}.slider[data-v-df8a36e6]:before{position:absolute;content:\"\";height:12px;width:12px;left:4px;bottom:2px;background-color:#676767;-webkit-transition:.4s;transition:.4s}input:checked+.slider[data-v-df8a36e6]{background-color:#fff}input:checked+.slider[data-v-df8a36e6]:before{left:18px;background-color:#4558dd}input:focus+.slider[data-v-df8a36e6]{-webkit-box-shadow:0 0 1px #4558dd;box-shadow:0 0 1px #4558dd}.slider.round[data-v-df8a36e6]{border-radius:34px;border:1px solid #000}.slider.round[data-v-df8a36e6]:before{border-radius:50%}.routename[data-v-df8a36e6]{color:#acacac;font-family:ProximanovaSemibold;float:left;font-size:18px;margin-right:10px}.routename.current[data-v-df8a36e6],.routename[data-v-df8a36e6]:hover{color:#212121}.backimg[data-v-df8a36e6]{float:left;margin-top:-5px;margin-right:1%}", "", {"version":3,"sources":["/home/mobiotics/Projects/vpremiere/src/components/Settings/settings.vue"],"names":[],"mappings":"AACA,6BAA6B,cAAc,4BAA8B,eAAe,mBAAmB,iBAAiB,cAAc,gBAAgB,CACzJ,AACD,0BAA0B,eAAiB,yCAA2C,CACrF,AACD,iCAAiC,WAAY,cAAc,gCAAkC,eAAe,kBAAkB,qBAAsB,iBAAiB,mBAAmB,yBAAyB,cAAc,CAC9N,AACD,kCAAkC,cAAc,cAAc,CAC7D,AACD,yBAAyB,kBAAkB,qBAAqB,WAAW,WAAW,CACrF,AACD,+BAA+B,UAAU,QAAQ,QAAQ,CACxD,AACD,yBAAyB,kBAAkB,eAAe,MAAM,OAAO,QAAQ,SAAS,uBAAwB,cAAe,CAC9H,AACD,gCAAgC,kBAAkB,WAAW,YAAY,WAAW,SAAS,WAAW,yBAAyB,uBAAwB,cAAe,CACvK,AACD,uCAAuC,qBAAwB,CAC9D,AACD,8CAA+C,UAAU,wBAAwB,CAChF,AACD,qCAAqC,mCAAmC,0BAA0B,CACjG,AACD,+BAA+B,mBAAmB,qBAAwB,CACzE,AACD,sCAAsC,iBAAiB,CACtD,AACD,4BAA4B,cAAc,gCAAkC,WAAW,eAAe,iBAAiB,CACtH,AAGD,sEAAkC,aAAa,CAC9C,AACD,0BAA0B,WAAW,gBAAgB,eAAe,CACnE","file":"settings.vue","sourcesContent":["\n.page-title[data-v-df8a36e6]{color:#212121;font-family:\"ProximanovaBold\";font-size:32px;letter-spacing:1px;line-height:49px;margin-top:2%;margin-bottom:1%\n}\n.hr-line[data-v-df8a36e6]{margin:1% 0 2% 0;border-bottom:1px solid rgba(10,10,10,0.44)\n}\n.setting-list p[data-v-df8a36e6]{opacity:0.9;color:#212121;font-family:\"ProximanovaSemibold\";font-size:18px;font-style:normal;letter-spacing:0.55px;line-height:27px;margin-bottom:18px;text-transform:uppercase;cursor:pointer\n}\n.marginleftright[data-v-df8a36e6]{margin-left:0;margin-right:0\n}\n.switch[data-v-df8a36e6]{position:relative;display:inline-block;width:36px;height:18px\n}\n.switch input[data-v-df8a36e6]{opacity:0;width:0;height:0\n}\n.slider[data-v-df8a36e6]{position:absolute;cursor:pointer;top:0;left:0;right:0;bottom:0;-webkit-transition:0.4s;transition:0.4s\n}\n.slider[data-v-df8a36e6]:before{position:absolute;content:\"\";height:12px;width:12px;left:4px;bottom:2px;background-color:#676767;-webkit-transition:0.4s;transition:0.4s\n}\ninput:checked+.slider[data-v-df8a36e6]{background-color:#ffffff\n}\ninput:checked+.slider[data-v-df8a36e6]::before{left:18px;background-color:#4558dd\n}\ninput:focus+.slider[data-v-df8a36e6]{-webkit-box-shadow:0 0 1px #4558dd;box-shadow:0 0 1px #4558dd\n}\n.slider.round[data-v-df8a36e6]{border-radius:34px;border:1px solid #000000\n}\n.slider.round[data-v-df8a36e6]:before{border-radius:50%\n}\n.routename[data-v-df8a36e6]{color:#acacac;font-family:\"ProximanovaSemibold\";float:left;font-size:18px;margin-right:10px\n}\n.routename.current[data-v-df8a36e6]{color:#212121\n}\n.routename[data-v-df8a36e6]:hover{color:#212121\n}\n.backimg[data-v-df8a36e6]{float:left;margin-top:-5px;margin-right:1%\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-lg-12 col-xlg-12",staticStyle:{"padding-left":"0","margin":"2% 0"}},[_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('img',{staticClass:"backimg",attrs:{"src":__webpack_require__(311)}})]),_vm._v(" "),_c('router-link',{attrs:{"to":{ name: 'Home' }}},[_c('div',{staticClass:"routename"},[_vm._v("Home /")])]),_vm._v(" "),_c('div',{staticClass:"routename current"},[_vm._v("Settings")])],1),_vm._v(" "),_c('div',{staticClass:"row marginleftright"},[_c('p',{staticClass:"page-title"},[_vm._v("Settings")]),_vm._v(" "),_c('div',{staticClass:"hr-line"}),_vm._v(" "),_c('div',{staticClass:"setting-list"},[(_vm.subscriberid)?_c('div',{staticClass:"row marginleftright"},[_c('p',{staticClass:"col-lg-3 col-md-4 col-sm-8 setting-menu",staticStyle:{"padding-left":"0","padding":"right:0"}},[_vm._v("\n            Notifications\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-md-3 col-sm-4"},[_c('label',{staticClass:"switch"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.notification),expression:"notification"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.notification)?_vm._i(_vm.notification,null)>-1:(_vm.notification)},on:{"change":[function($event){var $$a=_vm.notification,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.notification=$$a.concat([$$v]))}else{$$i>-1&&(_vm.notification=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.notification=$$c}},function($event){return _vm.notificationToggle()}]}}),_vm._v(" "),_c('span',{staticClass:"slider round"})])])]):_vm._e(),_vm._v(" "),_c('router-link',{attrs:{"to":"/help"},on:{"click":_vm.openHelpCenter}},[_c('p',{staticClass:"setting-menu"},[_vm._v("Help Center")])]),_vm._v(" "),_c('p',{staticClass:"setting-menu",on:{"click":_vm.openAboutPopup}},[_vm._v("About")])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__ = __webpack_require__(343);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df8a36e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__ = __webpack_require__(486);
function injectStyle (ssrContext) {
  __webpack_require__(484)
}
var normalizeComponent = __webpack_require__(8)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-df8a36e6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_df8a36e6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

});


// WEBPACK FOOTER //
// static/js/9.6230b3480fab873e5cfa.js